import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import axios from "axios";
import toonflix from "../images/toonflix.jpg";
import Select from 'react-select';
import {toast } from 'react-toastify';
import { base_url_toonflix } from "../Api/api";
import Lottie from 'lottie-react'
import loader from '../Animations/Loader2.json'

const GetHeaders = () => {

  const [selectedOption, setSelectedOption] = useState({ value: 'daily', label: 'Tous les jours/100 FCFA' })
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [tVal, setTVal] = useState(null);
  const [show, setShow] = useState(false);

  const urlParams = new URLSearchParams(window.location.search);
  const msisdn = urlParams.get('msisdn');
  const Ext_params = urlParams.get('extId');
  var ExtId = Ext_params;

  console.log('msisdn:', msisdn, 'extId:', ExtId);

  // ─── Step 1: Call POST /api/v1/evina/script ───────────────────────────────
  const getScript = async () => {
    setLoading(true);
    try {
      const res = await axios.post(`${base_url_toonflix}/api/v1/evina/script`, {
        serviceName: "ToonFlix",
        extId: Ext_params
      });

      console.log("Evina script response:", res.data);

      // res.data is an object: { t: '...', response: '{"t":"...","s":"<script>"}' }
      const parsed = JSON.parse(res.data.response);
      const scriptContent = parsed.s;
      const tValue = parsed.t;

    

setTVal(tValue);

// console.log("t value:", tValue);

      if (scriptContent) {
        let top_head = document.getElementsByTagName("head")[0];
        let anti_script = document.createElement("script");
        anti_script.innerHTML = scriptContent;
        top_head.insertBefore(anti_script, top_head.firstChild);

        var event = new Event("DCBProtectRun");
        document.dispatchEvent(event);
        document.addEventListener("gateway-load", (event) => {
          console.log(event, "EVENT LOADED");
        });
      }

      // Show the pack selector UI after script is loaded
      setShow(true);

    } catch (error) {
      console.error("Error fetching Evina script", error);
      setShow(true); // still show UI so user can try subscribing
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getScript();
  }, []);

  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      borderColor: state.isFocused ? 'rgb(234 88 12)' : 'gray',
      boxShadow: state.isFocused ? '0 0 0 1px rgb(234 88 12)' : 'none',
      '&:hover': {
        borderColor: state.isFocused ? 'rgb(234 88 12)' : 'gray',
      },
    }),
  };

  const navigate = useNavigate();

  const options = [
    { value: 'daily', label: 'Tous les jours/100 FCFA' },
    { value: 'weekly', label: 'Hebdomadaire/300 FCFA' },
    { value: 'monthly', label: 'Mensuelle/500 FCFA' },
  ];

  // Cookies.set('number', msisdn);
  // Cookies.set('extId', ExtId);

  // ─── Step 2: Call POST /api/v1/subscribe ──────────────────────────────────
  const handle = async () => {
    setLoading(true);

    const data = {
      msisdn: msisdn,
      packType: selectedOption.value,
      extId: ExtId,
      t: tVal,
      serviceName: "ToonFlix"
    };

    console.log("Subscribing with:", data);

    try {
      const res = await axios.post(`${base_url_toonflix}/api/v1/subscribe`, data);
      console.log("Subscribe response:", res.data);

// if (res.status === 200) {
      if (res.data?.statusCode === 200 && res.data?.code === 'SUCCESS') {

    toast.success(res.data.message);

     // cookies auto-clear 6 hours after successful subscribe
    Cookies.set('number', msisdn, { expires: 6/24 });
    Cookies.set('extId', ExtId, { expires: 6/24 });
    // navigate("/home");
    navigate(`/home?msisdn=${msisdn}`)
  } else if (res.data?.statusCode === 200 && res.data?.code === 'BILLING_PENDING') {

        toast.info(res.data?.message || "Facturation en attente.");

      } else {

        toast.error(res.data?.message || "Échec de l'abonnement");
      }   


// } catch (err) {
//  if (err.response?.status === 400) {
//     toast.error(err.response?.data?.message || "Bad Request");
// } else if (err.response?.status === 500) {
//     toast.error(err.response?.data?.message || "Internal Server Error");
// } else {
//     toast.error("Something went wrong");
// }
// }

} catch (err) {
      const status = err?.response?.status;
      const msg = err?.response?.data?.message;
      const code = err?.response?.data?.code;

      if (status === 409 && code === 'ACTIVE_SUBSCRIPTION') {
        toast.info(msg || "Abonnement déjà actif.");
        Cookies.set('number', msisdn, { expires: 6/24 });
        Cookies.set('extId', ExtId, { expires: 6/24 });
        navigate(`/home?msisdn=${msisdn}`);
      } else if (status === 400) {
        toast.error(msg || "Bad Request");
      } else if (status === 500) {
        toast.error(msg || "Internal Server Error");
      } else {
        toast.error(msg || "Something went wrong");
      }
    }

    setLoading(false);
  };

  return (
    <div className="fixed inset-0 overflow-y-auto bg-black/90 flex justify-center items-center z-10">
      {show ? (
        <>
          <div className="container mx-auto max-w-screen-sm bg-white rounded-md p-4 md:p-8 flex flex-col items-center shadow-lg relative">
            <img
              src={toonflix}
              alt="/"
              className="w-24 h-auto mb-4 md:mb-0 md:w-[200px]"
            />
            <form className="flex flex-col w-full md:w-2/3 px-4 py-4 md:py-8">
              <div className="text-center">
                <h1 className="text-2xl md:text-3xl font-bold mb-4 md:mb-6">
                  Sélectionnez le
                  <span className="text-orange-600 font-bold text-2xl md:text-3xl px-2">
                    Type de paquet
                  </span>
                </h1>
                <div>
                  <p className="text-center w-[90%] font-bold">
                    Toonflix est une plateforme de divertissement proposant des vidéos de dessins animés amusantes, éducatives et adaptées à l'âge des enfants.
                  </p>
                </div>
              </div>
              <p className='py-2 pt-4 text-lg font-semibold'>Type de paquet</p>
              <Select
                defaultValue={selectedOption}
                onChange={setSelectedOption}
                options={options}
                styles={customStyles}
              />
              <div className="flex mt-4 md:mt-6">
                <button
                  onClick={handle}
                  id="otp-send"
                  type='button'
                  className="w-full bg-orange-600 text-white py-2 px-4 rounded"
                  disabled={loading}
                >
                  {loading ? "Soumission..." : "s'abonner"}
                </button>
              </div>
              <div>
                <p
                  onClick={() => navigate('/tnc')}
                  className="text-blue-800 text-center mt-4 underline cursor-pointer"
                >
                  Conditions générales
                </p>
              </div>
            </form>
            <span className='text-xs font-semibold w-full text-center'>• Désinscription gratuite à tout moment : composez #303#10#.</span>
            <span className='text-xs font-semibold w-full text-center'>•Pour toute question ou assistance, veuillez contacter notre service client ou visiter notre page d'assistance, c'est-à-direpanz.support1@panzcon.com</span>
          </div>
        </>
      ) : (
        <>
          <Lottie animationData={loader} />
        </>
      )}
    </div>
  );
};

export default GetHeaders;
